import { useLoaderData, useParams } from "@remix-run/react";
// import { marked } from "marked";
import invariant from "tiny-invariant";
import type { ThemticFociDetailsPageProp } from "~/api/get_themenschwerpunkte_data.server";
import { fetchThemenschwerpunkteById } from "~/api/get_themenschwerpunkte_data.server";
import { ThemenschwerpunkteDetails } from "~/screens";
// import type { ArticleData } from "~/types";
import type { LinksFunction, V2_MetaFunction } from "@remix-run/node";
// import { json} from  "@remix-run/node";
import articlegallerystyle from "~/screens/articles/style/article_image.css";
import { RelatedMediaSection } from "~/shared";
// import lpOgImage from "~/assets/images/og_image.jpg";

export const links: LinksFunction = () => {
  return [{ rel: "stylesheet", href: articlegallerystyle }];
};

export const loader = async ({ request, params }: any) => {
  invariant(params.themeId, `params.articleId is required`);

  //   const cliend = apiClient();
  const { themeId } = params;

  try {
    const { data } = await fetchThemenschwerpunkteById({ id: themeId });
    return data;
  } catch (error: any) {
    // console.log("errerere method glosar", error);
    throw new Error(String(error.response?.data.message));
  }
};
export const meta: V2_MetaFunction<typeof loader> = ({ data }) => {
  // console.log("========data methode", data);
  if (!data) return [];
  return [
  { title: data.name },
  {
    property: "og:title",
    content: data.name
  },
  {
    name: "description",
    content: data.description
  },
  //@ts-ignore
  { property: "og:image", content: data?.picture?.file?.url }];

};
export default function ArticleDetail() {
  const { themeId } = useParams();
  const data = useLoaderData<{data: ThemticFociDetailsPageProp;}>();
  // console.log("data", data);
  return (
    <div className="flex flex-col">
      <div className="section-wrapper">
        <ThemenschwerpunkteDetails {...data} />
      </div>

      <div className="flex w-full flex-col md:pt-20">
        <RelatedMediaSection
        // need to set filter attributes later
        to={`/search/main?thematicFocusIds=${themeId}`}
        masonry={false}
        mediaCards={data.media.length ? data.media : []}
        title={
        <div className="mx-3">
              <h2 className="text-2xl text-textColor-primary lg:text-[48px] lg:leading-[1.167]">
                Passende Medien
              </h2>
              <p className="mt-5 max-w-6xl text-[18px] text-textColor-primary lg:leading-[1.556]">
                Redaktionell ausgesuchte und empfohlene Medien für die
                Unterrichtspraxis passend zum Themenschwerpunkt.
              </p>
            </div>} />


      </div>
    </div>);

}